import { useState } from 'react';

import { UseFormSetValue, UseFormWatch } from 'react-hook-form';

import { useMobileStore } from 'store/mobile.store';

import { AssociatedDocumentsDesktop } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/AssociatedDocuments/desktop/AssociatedDocuments.desktop';
import { AssociatedDocumentsMobile } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/AssociatedDocuments/mobile/AssociatedDocuments.mobile';
import { ExternalDocument } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/battlecards.types';

import classes from './AssociatedDocuments.module.scss';

interface IAssociatedDocuments {
    watch: UseFormWatch<any>;
    setValue: UseFormSetValue<any>;
}

export const AssociatedDocuments = ({ watch, setValue }: IAssociatedDocuments) => {
    const [showAddAssociatedDocuments, setShowAddAssociatedDocuments] = useState<boolean>(false);
    const isMobile = useMobileStore((state) => state.isMobile);

    const handleAddAssociatedDocumentsLinks = (data) => {
        setValue('externalLinks', [...watch('externalLinks'), { ...data.externalLink }], { shouldDirty: true });
        setShowAddAssociatedDocuments(false);
    };

    const handleDeleteAssociatedDocumentsLinks = (index) => {
        const externalLinksTemp = [...watch('externalLinks')];
        externalLinksTemp.splice(index, 1);
        setValue('externalLinks', externalLinksTemp, { shouldDirty: true });
    };

    const handleDeleteAssociatedDocuments = (id: number) => {
        const externalDocuments: ExternalDocument[] = [...watch('externalDocuments')];
        externalDocuments.forEach((document) => {
            if (document.id === id) {
                document.delete = true;
            }
        });
        setValue('externalDocuments', externalDocuments, { shouldDirty: true });
    };

    const handleAddAssociatedDocumentsFiles = (data) => {
        setValue('externalDocuments', [...watch('externalDocuments'), { ...data.externalDocument }], {
            shouldDirty: true,
        });
        setShowAddAssociatedDocuments(false);
    };

    const componentProps = {
        watch,
        setShowAddAssociatedDocuments,
        handleAddAssociatedDocumentsLinks,
        showAddAssociatedDocuments,
        handleAddAssociatedDocumentsFiles,
        handleDeleteAssociatedDocumentsLinks,
        handleDeleteAssociatedDocuments,
    };

    return (
        <div data-testid={'add-associated-documents-container'} className={classes.associatedDocumentsContainer}>
            {isMobile ? (
                <AssociatedDocumentsMobile {...componentProps} />
            ) : (
                <AssociatedDocumentsDesktop {...componentProps} />
            )}
        </div>
    );
};
